export default {
  addressBook: {
    cancel: 'Cancel',
    row: {
      actions: {
        change: 'Change',
      },
    },
    listView: {
      header: 'Choose Shipping Address',
      submit: 'Use Address',
    },
    createView: {
      header: 'Add a New Shipping Address',
      submit: 'Save & Use Address',
    },
    editView: {
      header: 'Edit Shipping Address',
      submit: 'Save & Use Address',
    },
  },
  shippingAddress: 'Shipping Address',
  cart: {
    startCheckout: 'Proceed to Checkout'
  }
}



// WEBPACK FOOTER //
// ./node_modules/@reverbdotcom/discovery-ui/src/translations/checkout/en.js